import {observer} from 'mobx-react-lite';
import React from 'react';

import {TabBarComponent} from '#/TabBar';
import {Props as TabBarItemProps} from '#/TabBar/Item';
import {GlobalTabBarItem} from '_/store/tabBar.store';

import {StyledCasusTabBar, StyledCasusTabBarItem} from './CasusTabBar.styles';

export const CasusTabBar =
  StyledCasusTabBar as unknown as typeof TabBarComponent;

function CasusTabComponent(
  props: TabBarItemProps<GlobalTabBarItem>
): React.ReactElement {
  return <StyledCasusTabBarItem splayCorner {...props} />;
}

export const CasusTab = observer(CasusTabComponent);
